const SDK_VERSION = '7.54.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
